import { CustomerOrderOfferState } from "src/api/generated/erp/db/types/enums/customerOrderOfferState.ts";

export const customerOrderOfferStatesAllowingLineEditing: Array<CustomerOrderOfferState> = [
	"INITIAL",
	"OFFERED",
	"AWAITING_ACCEPTANCE",
];

export const customerOrderOfferStatesAllowingOrderCreation: Array<CustomerOrderOfferState> = [
	"OFFERED",
	"AWAITING_ACCEPTANCE",
	"ACCEPTED",
];

export const customerOrderOfferStatesAllowingCancellation: Array<CustomerOrderOfferState> = [
	"INITIAL",
	"OFFERED",
	"AWAITING_ACCEPTANCE",
	"ACCEPTED",
];

export const canEditCustomerOrderOffer = (state: CustomerOrderOfferState) =>
	customerOrderOfferStatesAllowingLineEditing.includes(state);

export const canCreateCustomerOrderFromOffer = (state: CustomerOrderOfferState) =>
	customerOrderOfferStatesAllowingOrderCreation.includes(state);

export const canCancelCustomerOrderOffer = (state: CustomerOrderOfferState) =>
	customerOrderOfferStatesAllowingCancellation.includes(state);
